export default {
  title: 'Démarrer votre abonnement',
  title_confirm: 'Confirmez votre offre',
  step: 'Étape {{current}} sur {{total}}',
  subtitle: '{{name}} · 1 établissement',
  trial_badge: '{{days}} jours gratuits',
  trial_headline: '{{days}} premiers jours gratuits',
  then_price: 'Puis {{price}} / mois par établissement · TVA incluse',
  price_per_month: '{{price}} / mois',
  price_terms: 'Par établissement, facturé mensuellement · TVA incluse',
  tier_upsell:
    'Passez à {{threshold}}+ établissements actifs et le tarif de tous vos établissements passe à {{price}} / mois par établissement — automatiquement.',
  tier_active: 'Tarif dégressif — {{threshold}}+ établissements actifs',
  due_today: "À payer aujourd'hui",
  from_date: 'À partir du {{date}}',
  no_charge_today: "Vous ne serez pas débité aujourd'hui.",
  no_charge_until: 'Vous ne serez pas débité aujourd’hui. Annulez au plus tard le {{date}} et vous ne payez rien.',
  active: '{{plan}} est actif pour ce restaurant.',
  active_with_trial: "{{plan}} est actif pour ce restaurant, gratuit jusqu'au {{date}}.",
  terms:
    'J\'accepte les <a href="{{terms_url}}" target="_blank" rel="noreferrer">Conditions de la plateforme partenaire FoodAmigos</a>, y compris l\'activation, l\'annulation et les remboursements.',
  error: "Nous n'avons pas pu finaliser l'achat. Veuillez réessayer.",
  loading: 'Vérification du forfait de ce restaurant…',
  load_error: 'Impossible de vérifier le forfait de ce restaurant.',
  unavailable:
    'Ce produit n’est pas disponible pour ce restaurant. Veuillez contacter votre gestionnaire de compte FoodAmigos.',
  products: {
    online_ordering: {
      features: {
        ordering: {
          title: 'Commande en ligne',
          description: 'Commandes directes sur le site web du restaurant',
        },
        reservations: {
          title: 'Réservations de table',
          description: 'Les clients réservent une table directement en ligne',
        },
        marketing: {
          title: 'Suite Marketing',
          description: "Créateur d'offres, programme de fidélité et réponses IA aux avis Google",
        },
        pricing: {
          title: "0 % de commission, aucun frais d'installation",
          description: 'Une licence par établissement, facturée mensuellement',
        },
      },
    },
    mobile_app: {
      features: {
        app: {
          title: "L'application du restaurant à ses couleurs",
          description: "Sur l'App Store et Google Play",
        },
        engagement: {
          title: 'Notifications push et fidélité',
          description: 'Fidélisez les clients avec des offres et des points',
        },
        ordering: {
          title: 'Commande à 0 % de commission',
          description: "Commandes directes depuis l'application",
        },
        apple: {
          title: 'Compte Apple Developer requis',
          description: "99 $/an, payés à Apple, au nom de l'entité légale du restaurant",
        },
      },
    },
    ai_website: {
      title: 'Abonnement Créateur de site web',
      subtitle_domain: 'Mettez en ligne le site de {{name}} sur {{domain}}',
      features: {
        domain: {
          title: 'Votre site web, en ligne sur votre propre domaine',
          description: 'Le site web du restaurant à ses couleurs',
        },
        ai: {
          title: "Créé et mis à jour avec l'IA",
          description: 'Créez pages, textes et images pour le restaurant en quelques minutes',
        },
        ordering: {
          title: 'Commande et réservations intégrées',
          description: 'Les clients commandent et réservent une table directement depuis le site',
        },
        pricing: {
          title: "Aucun frais d'installation",
          description: 'Une licence par établissement, facturée mensuellement',
        },
      },
    },
    storefront: {
      title: 'Abonnement Créateur de site web',
      subtitle_domain: 'Mettez en ligne le site de {{name}} sur {{domain}}',
      features: {
        domain: {
          title: 'Votre site web, en ligne sur votre propre domaine',
          description: 'Le site web du restaurant à ses couleurs',
        },
        ai: {
          title: "Créé et mis à jour avec l'IA",
          description: 'Créez pages, textes et images pour le restaurant en quelques minutes',
        },
        ordering: {
          title: 'Commande et réservations intégrées',
          description: 'Les clients commandent et réservent une table directement depuis le site',
        },
        pricing: {
          title: "Aucun frais d'installation",
          description: 'Une licence par établissement, facturée mensuellement',
        },
      },
    },
  },
  payment_method: {
    label: 'Votre moyen de paiement partenaire',
    on_file: 'Carte enregistrée',
    pending_title: 'Confirmation de votre moyen de paiement',
    pending: "Stripe confirme encore la carte que vous venez d'ajouter. Cela peut prendre une minute.",
    still_pending: 'Pas encore. Patientez un instant et vérifiez à nouveau.',
    error: "Impossible d'ouvrir le formulaire de paiement. Veuillez réessayer.",
  },
  buttons: {
    close: 'Fermer',
    continue_to_payment: 'Continuer vers le paiement',
    start_trial: "Démarrer l'essai gratuit de {{days}} jours",
    subscribe: "Démarrer l'abonnement",
    continue: 'Continuer',
    change: 'Modifier',
    retry: 'Réessayer',
    check_again: 'Revérifier',
    add_again: 'Ajouter une nouvelle carte',
  },
};
